var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetrofit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4CBA86;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.7,70c-5.4,0-11,0-16.4,0c-5.6,0-9.1-3.4-9.1-9.3c0-10.6,0-21.3,0-31.9c0-5.4,3.4-8.8,8.8-8.8 c11.2,0,22.6,0,33.8,0c5.4,0,8.8,3.4,8.8,8.8c0,10.8,0,21.6,0,32.1c0,5.6-3.4,8.8-9.1,9.1C75.9,70,70.3,70,64.7,70z M64.7,60.9 c4.1,0,8.2,0,12.5,0c3.4,0,4.3-0.6,4.3-4.1c0-8,0-15.7,0-23.7c0-3.2-0.9-4.1-4.1-4.1c-8.2,0-16.6,0-24.8,0c-3,0-3.9,0.9-3.9,3.9 c0,8.2,0,16.2,0,24.4c0,2.6,1.1,3.9,3.7,3.7C56.5,60.7,60.6,60.9,64.7,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.9,51.9c-7.8,0-6.9,0.9-6.9-6.9c0-7.5-0.9-6.7,6.7-6.7c8.2,0,7.1-1.1,7.3,7.1C72,52.8,72.9,51.7,64.9,51.9z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetrofit);
export default __webpack_public_path__ + "static/media/Retrofit.7b7711e95d9f73269065be9329da3eb3.svg";
export { ForwardRef as ReactComponent };